import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { CommonService } from 'src/app-core/services/common.service';

@Injectable({
    providedIn: 'root',
})

export class CustomerService {

    constructor(
        private apiCommonService: ApiCommonService,
        private commonService: CommonService) {
    }

    getAccountsGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Accounts', event, searchQuery, statusQuery, '');
    }

    createAccount(data: object): Observable<any> {
        return this.apiCommonService.post('Accounts', data);
    }

    getAccount(accountId: string): Observable<any> {
        return this.apiCommonService.get(`Accounts/Id?Id=${accountId}`);
    }

    editAccount(customerId: string): Observable<any> {
        return this.apiCommonService.get(`Accounts/Edit?Id=${customerId}`);
    }

    updateAccount(data: object): Observable<object> {
        return this.apiCommonService.post('Accounts/Update', data);
    }

    exportAccounts(event: any, searchQuery: string, queryString): Observable<object> {
        return this.apiCommonService.export('Accounts/export', event, searchQuery, queryString, '');
    }

    AccountStatusUpdate(data: object): Observable<object> {
        return this.apiCommonService.put('Accounts/Delete', data);
    }

    AccountJobse(data: object): Observable<object> {
        return this.apiCommonService.put('Accounts/Delete', data);
    }

    getAccountOrdersGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Orders/OrdersByAccount', event, searchQuery, statusQuery, '');
    }

    getAccountStatusList(): Observable<any> {
        return this.apiCommonService.get(`Accounts/StatusLookup`);
    }

    getAccountFiltersCounts(queryParams: string): Observable<any> {
        return this.apiCommonService.get(`Accounts/LeftMenuWithCount?${queryParams}`);
    }

    convertToFullAccount(data: object): Observable<any> {
        return this.apiCommonService.post('Accounts/ConvertToFullAccount', data);
    }

    getTotalRevenueLostOutstandingQuoted(queryParams: string): Observable<any> {
        return this.apiCommonService.get(`Orders/TotalRevenueLostOutstandingQuoted?AccountId=${queryParams}`);
    }
}
